import React from 'react';
import Pagination from '../../../components/base/Pagination/Pagination';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { MoreFormatter } from '../../../utils/formatters';
import { addUserActionLogColumns, userActionLogColumns } from '../constants';

export default function UserActionLogGrid(props) {
  const {
    data = [],
    loadData = () => {},
    meta = {},
  } = props;

  return (
    <div className="elp-table g-0">
      <div className="frame">
        <div className="sticky-table-wrapper custom-scroll-theme">
          <CustomizedGrid className="elp-grid" data={data} columns={userActionLogColumns} additionalColumns={addUserActionLogColumns} name="ual-list" settingsFormatter={MoreFormatter} />
        </div>
      </div>
      <Pagination meta={meta} list={data} handleChangeMeta={loadData} />
    </div>
  );
}
